import React, { memo, useCallback } from 'react';
import RichTextInput from 'components/RichTextInput';
import Base from './Base';

const RichText = memo(
    ({
        canClear,
        canToggle,
        description,
        fieldExtraValue,
        hidden,
        hint,
        isBulkAction,
        label,
        labelMode,
        mandatory,
        onChange,
        onClear,
        value = {},
        willBeCleared,
    }) => {
        const handleChange = useCallback(
            (newValue) => {
                onChange && onChange(newValue);
            },
            [onChange],
        );

        if (hidden) return null;

        return (
            <div className="fm-field-richtext">
                <Base
                    canClear={canClear}
                    canToggle={canToggle}
                    description={description}
                    fieldExtraValue={fieldExtraValue}
                    isBulkAction={isBulkAction}
                    label={label}
                    labelMode={labelMode}
                    mandatory={mandatory}
                    onClear={onClear}
                    onReset={onChange}
                    willBeCleared={willBeCleared}
                >
                    <RichTextInput
                        defaultValue={value.html || value.text}
                        hint={hint}
                        onChange={handleChange}
                    />
                </Base>
            </div>
        );
    },
);

RichText.displayName = 'RichText';

export default RichText;
